import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, InputNumber, DatePicker, Icon, notification, Checkbox, Radio, Divider } from "antd";
import axios from "axios";
import moment from "moment";
import SectionCard from "../../components/SectionCard";
import SectionDivider from "../../components/SectionDivider";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const DrawerAdicionarEstudo = ({ id, pastaId, visible, atualizarListagem, onClose, form }) => {
    const estadoInicial = {
        id: undefined,
        id_disciplina: undefined,
        tipo: "estudo_caso_fundamental",

        nome_crianca: "",
        turma_ano: "",
        idade: null,
        professor: "",
        data_registro: moment(),

        familia_trajetoria_escolar: {
            responsavel: "",
            contato: "",
            relacao_familia_escola: "",
            marcacoes: [],
            outro: "",
            relato_familia_sobre_aluno: ""
        },

        estudante_contexto_escolar: {
            marcacoes: [],
            comportamento_sala: "",
            participacao_atividades: [],
            participacao_outro: ""
        },

        identificacao_demandas_barreiras: {
            marcacoes: [],
            outro: ""
        },

        potencialidades_aluno: {
            o_que_faz_bem: "",
            interesses_hiperfocos: "",
            habilidades_talentos: "",
            caracteristicas_positivas: ""
        },

        necessidades_apoio: {
            marcacoes: [],
            outro: "",
            tipo_apoio_necessario: ""
        },

        estrategias_pedagogicas: {
            estrategias_utilizadas: "",
            funcionaram: null,
            novas_estrategias: ""
        },

        observacoes_familia: {
            relato_desenvolvimento: "",
            estrategias_funcionam_casa: ""
        },

        alinhamento_escola_familia: {
            familia_ciente_intervencoes: null,
            familia_disponibilidade_parceria: null,
            familia_atividades_terapias_externas: null,
            familia_atividades_terapias_dias: [],
            familia_atividades_terapias_quais: "",
            combinado_escola_familia: ""
        },

        recomendacoes_finais: ""
    };

    const [registo, setRegisto] = useState(estadoInicial);
    const [isLoading, setIsLoading] = useState(false);

    const opcoesFamiliaTrajetoria = [
        "Dificuldades de aprendizagem",
        "Crises comportamentais",
        "Troca de escola frequente",
        "Dificuldades de socialização",
        "Reprovação",
        "Outro"
    ];

    const opcoesEstudanteContexto = [
        "Dificuldades de aprendizagem",
        "Crises comportamentais",
        "Troca de escola frequente",
        "Dificuldades de socialização",
        "Reprovação",
        "Outro"
    ];

    const opcoesParticipacaoAtividades = ["Participa com autonomia", "Precisa de apoio", "Resistência às atividades", "Outro"];

    const opcoesDemandasBarreiras = [
        "Leitura",
        "Escrita",
        "Matemática",
        "Sensorial",
        "Atenção/concentração",
        "Comportamento",
        "Comunicação",
        "Outro"
    ];

    const opcoesNecessidadesApoio = [
        "Adaptação curricular",
        "Organização",
        "Atenção",
        "Regulação emocional",
        "Concentração",
        "Socialização",
        "Comunicação",
        "Outro"
    ];

    const opcoesDiasSemana = ["2ª", "3ª", "4ª", "5ª", "6ª"];

    const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = form;

    const temOpcaoOutroSelecionada = fieldName => {
        const valores = getFieldValue(fieldName) || [];
        return valores.includes("Outro");
    };

    const mostrarTerapiasExternas = getFieldValue("alinhamento_familia_atividades_terapias_externas") === "sim";

    const renderCheckboxSection = (label, fieldName, options, initialValue = []) => (
        <div style={{ marginBottom: 24 }}>
            <Divider orientation="left" style={{ fontWeight: "bold" }}>
                {label}
            </Divider>
            <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator(fieldName, {
                    initialValue
                })(
                    <Checkbox.Group style={{ width: "100%" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            {options.map(opcao => (
                                <Checkbox key={opcao} value={opcao}>
                                    {opcao}
                                </Checkbox>
                            ))}
                        </div>
                    </Checkbox.Group>
                )}
            </Form.Item>
        </div>
    );

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                if (id) {
                    alterarEstudo(values);
                } else {
                    adicionarEstudo(values);
                }
            }
        });
    };

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-estudo-infantil",
            params: { id }
        })
            .then(response => {
                const data = response.data;

                const familia_trajetoria_escolar = parseObject(data.familia_trajetoria_escolar, {
                    responsavel: "",
                    contato: "",
                    relacao_familia_escola: "",
                    marcacoes: [],
                    outro: "",
                    relato_familia_sobre_aluno: ""
                });

                const estudante_contexto_escolar = parseObject(data.estudante_contexto_escolar, {
                    marcacoes: [],
                    comportamento_sala: "",
                    participacao_atividades: [],
                    participacao_outro: ""
                });

                const identificacao_demandas_barreiras = parseObject(data.identificacao_demandas_barreiras, {
                    marcacoes: [],
                    outro: ""
                });

                const potencialidades_aluno = parseObject(data.potencialidades_aluno, {
                    o_que_faz_bem: "",
                    interesses_hiperfocos: "",
                    habilidades_talentos: "",
                    caracteristicas_positivas: ""
                });

                const necessidades_apoio = parseObject(data.necessidades_apoio, {
                    marcacoes: [],
                    outro: "",
                    tipo_apoio_necessario: ""
                });

                const estrategias_pedagogicas = parseObject(data.estrategias_pedagogicas, {
                    estrategias_utilizadas: "",
                    funcionaram: null,
                    novas_estrategias: ""
                });

                const observacoes_familia = parseObject(data.observacoes_familia, {
                    relato_desenvolvimento: "",
                    estrategias_funcionam_casa: ""
                });

                const alinhamento_escola_familia = parseObject(data.alinhamento_escola_familia, {
                    familia_ciente_intervencoes: null,
                    familia_disponibilidade_parceria: null,
                    familia_atividades_terapias_externas: null,
                    familia_atividades_terapias_dias: [],
                    familia_atividades_terapias_quais: "",
                    combinado_escola_familia: ""
                });

                const dados = {
                    ...data,
                    nome_crianca: data.nome_crianca || "",
                    turma_ano: data.turma_ano || "",
                    idade: data.idade ?? null,
                    professor: data.professor || "",
                    data_registro: data.data_registro ? moment(data.data_registro) : moment(),
                    familia_trajetoria_escolar,
                    estudante_contexto_escolar,
                    identificacao_demandas_barreiras,
                    potencialidades_aluno,
                    necessidades_apoio,
                    estrategias_pedagogicas,
                    observacoes_familia,
                    alinhamento_escola_familia,
                    recomendacoes_finais: data.recomendacoes_finais || ""
                };

                setRegisto(dados);

                setFieldsValue({
                    nome_crianca: dados.nome_crianca,
                    turma_ano: dados.turma_ano,
                    idade: dados.idade,
                    professor: dados.professor,
                    data_registro: dados.data_registro,

                    familia_responsavel: dados.familia_trajetoria_escolar.responsavel || "",
                    familia_contato: dados.familia_trajetoria_escolar.contato || "",
                    familia_relacao_escola: dados.familia_trajetoria_escolar.relacao_familia_escola || "",
                    familia_trajetoria_marcacoes: dados.familia_trajetoria_escolar.marcacoes || [],
                    familia_trajetoria_outro: dados.familia_trajetoria_escolar.outro || "",
                    familia_relato_aluno: dados.familia_trajetoria_escolar.relato_familia_sobre_aluno || "",

                    estudante_contexto_marcacoes: dados.estudante_contexto_escolar.marcacoes || [],
                    estudante_comportamento_sala: dados.estudante_contexto_escolar.comportamento_sala || "",
                    estudante_participacao_atividades: dados.estudante_contexto_escolar.participacao_atividades || [],
                    estudante_participacao_outro: dados.estudante_contexto_escolar.participacao_outro || "",

                    demandas_barreiras_marcacoes: dados.identificacao_demandas_barreiras.marcacoes || [],
                    demandas_barreiras_outro: dados.identificacao_demandas_barreiras.outro || "",

                    potencialidades_o_que_faz_bem: dados.potencialidades_aluno.o_que_faz_bem || "",
                    potencialidades_interesses_hiperfocos: dados.potencialidades_aluno.interesses_hiperfocos || "",
                    potencialidades_habilidades_talentos: dados.potencialidades_aluno.habilidades_talentos || "",
                    potencialidades_caracteristicas_positivas: dados.potencialidades_aluno.caracteristicas_positivas || "",

                    necessidades_apoio_marcacoes: dados.necessidades_apoio.marcacoes || [],
                    necessidades_apoio_outro: dados.necessidades_apoio.outro || "",
                    necessidades_tipo_apoio: dados.necessidades_apoio.tipo_apoio_necessario || "",

                    estrategias_utilizadas: dados.estrategias_pedagogicas.estrategias_utilizadas || "",
                    estrategias_funcionaram: dados.estrategias_pedagogicas.funcionaram || null,
                    estrategias_novas: dados.estrategias_pedagogicas.novas_estrategias || "",

                    observacoes_familia_relato: dados.observacoes_familia.relato_desenvolvimento || "",
                    observacoes_familia_estrategias: dados.observacoes_familia.estrategias_funcionam_casa || "",

                    alinhamento_familia_ciente_intervencoes: dados.alinhamento_escola_familia.familia_ciente_intervencoes || null,
                    alinhamento_familia_disponibilidade_parceria: dados.alinhamento_escola_familia.familia_disponibilidade_parceria || null,
                    alinhamento_familia_atividades_terapias_externas:
                        dados.alinhamento_escola_familia.familia_atividades_terapias_externas || null,
                    alinhamento_familia_atividades_dias: dados.alinhamento_escola_familia.familia_atividades_terapias_dias || [],
                    alinhamento_familia_atividades_quais: dados.alinhamento_escola_familia.familia_atividades_terapias_quais || "",
                    alinhamento_combinado_escola_familia: dados.alinhamento_escola_familia.combinado_escola_familia || "",

                    recomendacoes_finais: dados.recomendacoes_finais || ""
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar detalhe.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const montarPayload = values => {
        const familiaTrajetoriaMarcacoes = values.familia_trajetoria_marcacoes || [];
        const estudanteParticipacaoAtividades = values.estudante_participacao_atividades || [];
        const demandasBarreirasMarcacoes = values.demandas_barreiras_marcacoes || [];
        const necessidadesApoioMarcacoes = values.necessidades_apoio_marcacoes || [];

        return {
            id_disciplina: localStorage.getItem("codigo_curso"),
            tipo: "estudo_caso_fundamental",
            nome_crianca: values.nome_crianca,
            turma_ano: values.turma_ano,
            idade: values.idade,
            professor: values.professor,
            data_registro: values.data_registro ? values.data_registro.format("YYYY-MM-DD") : null,

            familia_trajetoria_escolar: JSON.stringify({
                responsavel: values.familia_responsavel || "",
                contato: values.familia_contato || "",
                relacao_familia_escola: values.familia_relacao_escola || "",
                marcacoes: familiaTrajetoriaMarcacoes,
                outro: familiaTrajetoriaMarcacoes.includes("Outro") ? values.familia_trajetoria_outro || "" : "",
                relato_familia_sobre_aluno: values.familia_relato_aluno || ""
            }),

            estudante_contexto_escolar: JSON.stringify({
                marcacoes: values.estudante_contexto_marcacoes || [],
                comportamento_sala: values.estudante_comportamento_sala || "",
                participacao_atividades: estudanteParticipacaoAtividades,
                participacao_outro: estudanteParticipacaoAtividades.includes("Outro") ? values.estudante_participacao_outro || "" : ""
            }),

            identificacao_demandas_barreiras: JSON.stringify({
                marcacoes: demandasBarreirasMarcacoes,
                outro: demandasBarreirasMarcacoes.includes("Outro") ? values.demandas_barreiras_outro || "" : ""
            }),

            potencialidades_aluno: JSON.stringify({
                o_que_faz_bem: values.potencialidades_o_que_faz_bem || "",
                interesses_hiperfocos: values.potencialidades_interesses_hiperfocos || "",
                habilidades_talentos: values.potencialidades_habilidades_talentos || "",
                caracteristicas_positivas: values.potencialidades_caracteristicas_positivas || ""
            }),

            necessidades_apoio: JSON.stringify({
                marcacoes: necessidadesApoioMarcacoes,
                outro: necessidadesApoioMarcacoes.includes("Outro") ? values.necessidades_apoio_outro || "" : "",
                tipo_apoio_necessario: values.necessidades_tipo_apoio || ""
            }),

            estrategias_pedagogicas: JSON.stringify({
                estrategias_utilizadas: values.estrategias_utilizadas || "",
                funcionaram: values.estrategias_funcionaram || null,
                novas_estrategias: values.estrategias_novas || ""
            }),

            observacoes_familia: JSON.stringify({
                relato_desenvolvimento: values.observacoes_familia_relato || "",
                estrategias_funcionam_casa: values.observacoes_familia_estrategias || ""
            }),

            alinhamento_escola_familia: JSON.stringify({
                familia_ciente_intervencoes: values.alinhamento_familia_ciente_intervencoes || null,
                familia_disponibilidade_parceria: values.alinhamento_familia_disponibilidade_parceria || null,
                familia_atividades_terapias_externas: values.alinhamento_familia_atividades_terapias_externas || null,
                familia_atividades_terapias_dias: values.alinhamento_familia_atividades_dias || [],
                familia_atividades_terapias_quais: values.alinhamento_familia_atividades_quais || "",
                combinado_escola_familia: values.alinhamento_combinado_escola_familia || ""
            }),

            recomendacoes_finais: values.recomendacoes_finais || ""
        };
    };

    const adicionarEstudo = values => {
        setIsLoading(true);

        const estudo = montarPayload(values);

        axios({
            method: "post",
            url: "/api/estudo-caso/adicionar-plano-estudo-infantil",
            data: estudo
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso criado com sucesso.");
                atualizarListagem(response.data);
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao criar o estudo.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const alterarEstudo = values => {
        setIsLoading(true);

        const estudo = {
            id,
            ...montarPayload(values)
        };

        axios({
            method: "put",
            url: "/api/estudo-caso/alterar-plano-estudo-infantil",
            data: estudo
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso alterado com sucesso.");
                atualizarListagem();
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao alterar o estudo.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const carregarDadosAluno = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes",
            params: {
                pastaId,
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    nome_crianca: aluno?.nome || "",
                    turma_ano: turma?.nome || "",
                    idade: aluno?.idade ?? null,
                    professor: turma?.professor || ""
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    nome_crianca: aluno?.nome || "",
                    turma_ano: turma?.nome || "",
                    idade: aluno?.idade ?? null,
                    professor: turma?.professor || ""
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && !id) {
            limparCampos();
        }
    };

    const limparCampos = () => {
        resetFields();
        setRegisto({
            ...estadoInicial,
            data_registro: moment()
        });
    };

    useEffect(() => {
        if (visible && id) {
            carregarDetalhe(id);
        }

        if (pastaId && visible) {
            carregarDadosAluno();
        }

        if (visible && !id && !pastaId) {
            carregarDadosAlunoEnsinoEspecial();
        }

        if (visible && !id) {
            limparCampos();
        }
    }, [id, visible]);

    return (
        <Drawer
            className="drawer-adicionar-evento drawer-add-cursos"
            width={720}
            onClose={handleClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="1. Dados da criança">
                        <Form.Item label="Data" style={{ width: 220 }}>
                            {getFieldDecorator("data_registro", {
                                initialValue: registo.data_registro,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />)}
                        </Form.Item>

                        <Form.Item label="Nome do aluno">
                            {getFieldDecorator("nome_crianca", {
                                initialValue: registo.nome_crianca,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Turma/ano" style={{ flex: 1 }}>
                            {getFieldDecorator("turma_ano", {
                                initialValue: registo.turma_ano,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Idade" style={{ flex: 1 }}>
                            {getFieldDecorator("idade", {
                                initialValue: registo.idade,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<InputNumber style={{ width: "100%" }} min={0} />)}
                        </Form.Item>

                        <Form.Item label="Professor(a)" style={{ flex: 1 }}>
                            {getFieldDecorator("professor", {
                                initialValue: registo.professor,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="2. Conhecendo a família e a trajetória escolar">
                        <Form.Item label="Responsável">
                            {getFieldDecorator("familia_responsavel", {
                                initialValue: registo.familia_trajetoria_escolar?.responsavel
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Contato">
                            {getFieldDecorator("familia_contato", {
                                initialValue: registo.familia_trajetoria_escolar?.contato
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Como é a relação da família com a escola">
                            {getFieldDecorator("familia_relacao_escola", {
                                initialValue: registo.familia_trajetoria_escolar?.relacao_familia_escola
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        {/* {renderCheckboxSection(
                            "Trajetória escolar / histórico",
                            "familia_trajetoria_marcacoes",
                            opcoesFamiliaTrajetoria,
                            registo.familia_trajetoria_escolar?.marcacoes || []
                        )} */}

                        {/* <Form.Item
                            label="Descreva o outro"
                            style={{ display: temOpcaoOutroSelecionada("familia_trajetoria_marcacoes") ? "block" : "none" }}
                        >
                            {getFieldDecorator("familia_trajetoria_outro", {
                                initialValue: registo.familia_trajetoria_escolar?.outro
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Relato da família sobre o aluno">
                            {getFieldDecorator("familia_relato_aluno", {
                                initialValue: registo.familia_trajetoria_escolar?.relato_familia_sobre_aluno
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item> */}
                    </SectionCard>

                    <SectionCard title="3. Observação do estudante no contexto escolar">
                        {renderCheckboxSection(
                            "Itens observados",
                            "estudante_contexto_marcacoes",
                            opcoesEstudanteContexto,
                            registo.estudante_contexto_escolar?.marcacoes || []
                        )}

                        <Form.Item label="Como o aluno se comporta em sala de aula">
                            {getFieldDecorator("estudante_comportamento_sala", {
                                initialValue: registo.estudante_contexto_escolar?.comportamento_sala
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        {renderCheckboxSection(
                            "Participação nas atividades",
                            "estudante_participacao_atividades",
                            opcoesParticipacaoAtividades,
                            registo.estudante_contexto_escolar?.participacao_atividades || []
                        )}

                        <Form.Item
                            label="Descreva o outro"
                            style={{ display: temOpcaoOutroSelecionada("estudante_participacao_atividades") ? "block" : "none" }}
                        >
                            {getFieldDecorator("estudante_participacao_outro", {
                                initialValue: registo.estudante_contexto_escolar?.participacao_outro
                            })(<Input />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="4. Identificação de demandas e barreiras">
                        {renderCheckboxSection(
                            "Quais dificuldades o aluno apresenta",
                            "demandas_barreiras_marcacoes",
                            opcoesDemandasBarreiras,
                            registo.identificacao_demandas_barreiras?.marcacoes || []
                        )}

                        <Form.Item
                            label="Descreva o outro"
                            style={{ display: temOpcaoOutroSelecionada("demandas_barreiras_marcacoes") ? "block" : "none" }}
                        >
                            {getFieldDecorator("demandas_barreiras_outro", {
                                initialValue: registo.identificacao_demandas_barreiras?.outro
                            })(<Input />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="5. Potencialidades do aluno">
                        <Form.Item label="O que o aluno faz bem">
                            {getFieldDecorator("potencialidades_o_que_faz_bem", {
                                initialValue: registo.potencialidades_aluno?.o_que_faz_bem
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Form.Item label="Interesses / hiperfocos">
                            {getFieldDecorator("potencialidades_interesses_hiperfocos", {
                                initialValue: registo.potencialidades_aluno?.interesses_hiperfocos
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Form.Item label="Habilidades e talentos observados">
                            {getFieldDecorator("potencialidades_habilidades_talentos", {
                                initialValue: registo.potencialidades_aluno?.habilidades_talentos
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Form.Item label="Características positivas do aluno">
                            {getFieldDecorator("potencialidades_caracteristicas_positivas", {
                                initialValue: registo.potencialidades_aluno?.caracteristicas_positivas
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="6. Necessidades de apoio">
                        {renderCheckboxSection(
                            "O aluno necessita de apoio para",
                            "necessidades_apoio_marcacoes",
                            opcoesNecessidadesApoio,
                            registo.necessidades_apoio?.marcacoes || []
                        )}

                        <Form.Item
                            label="Descreva o outro"
                            style={{ display: temOpcaoOutroSelecionada("necessidades_apoio_marcacoes") ? "block" : "none" }}
                        >
                            {getFieldDecorator("necessidades_apoio_outro", {
                                initialValue: registo.necessidades_apoio?.outro
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Tipo de apoio necessário">
                            {getFieldDecorator("necessidades_tipo_apoio", {
                                initialValue: registo.necessidades_apoio?.tipo_apoio_necessario
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="7. Estratégias pedagógicas">
                        <Form.Item label="Estratégias já utilizadas">
                            {getFieldDecorator("estrategias_utilizadas", {
                                initialValue: registo.estrategias_pedagogicas?.estrategias_utilizadas
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Form.Item label="Funcionaram?">
                            {getFieldDecorator("estrategias_funcionaram", {
                                initialValue: registo.estrategias_pedagogicas?.funcionaram
                            })(
                                <Radio.Group>
                                    <Radio value="sim">Sim</Radio>
                                    <Radio value="nao">Não</Radio>
                                    <Radio value="parcialmente">Parcialmente</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="Novas estratégias a aplicar">
                            {getFieldDecorator("estrategias_novas", {
                                initialValue: registo.estrategias_pedagogicas?.novas_estrategias
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="8. Observações da família">
                        <Form.Item label="Relato sobre o desenvolvimento do aluno e principais preocupações da família">
                            {getFieldDecorator("observacoes_familia_relato", {
                                initialValue: registo.observacoes_familia?.relato_desenvolvimento
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Form.Item label="O que a família considera que ajuda o aluno a aprender melhor?">
                            {getFieldDecorator("observacoes_familia_estrategias", {
                                initialValue: registo.observacoes_familia?.estrategias_funcionam_casa
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="9. Alinhamento Escola e Família">
                        <Form.Item label="A família está ciente das intervenções pedagógicas">
                            {getFieldDecorator("alinhamento_familia_ciente_intervencoes", {
                                initialValue: registo.alinhamento_escola_familia?.familia_ciente_intervencoes
                            })(
                                <Radio.Group>
                                    <Radio value="sim">Sim</Radio>
                                    <Radio value="parcialmente">Parcialmente</Radio>
                                    <Radio value="nao">Não</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="A família demonstra disponibilidade para parceria com a escola">
                            {getFieldDecorator("alinhamento_familia_disponibilidade_parceria", {
                                initialValue: registo.alinhamento_escola_familia?.familia_disponibilidade_parceria
                            })(
                                <Radio.Group>
                                    <Radio value="sim">Sim</Radio>
                                    <Radio value="parcialmente">Parcialmente</Radio>
                                    <Radio value="nao">Não</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="A família leva o estudante para atividades ou terapias externas">
                            {getFieldDecorator("alinhamento_familia_atividades_terapias_externas", {
                                initialValue: registo.alinhamento_escola_familia?.familia_atividades_terapias_externas
                            })(
                                <Radio.Group>
                                    <Radio value="sim">Sim</Radio>
                                    <Radio value="nao">Não</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="Dias da semana" style={{ display: mostrarTerapiasExternas ? "block" : "none" }}>
                            {getFieldDecorator("alinhamento_familia_atividades_dias", {
                                initialValue: registo.alinhamento_escola_familia?.familia_atividades_terapias_dias || []
                            })(
                                <Checkbox.Group style={{ width: "100%" }}>
                                    {opcoesDiasSemana.map(dia => (
                                        <Checkbox key={dia} value={dia} style={{ marginRight: 12 }}>
                                            {dia}
                                        </Checkbox>
                                    ))}
                                </Checkbox.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="Quais" style={{ display: mostrarTerapiasExternas ? "block" : "none" }}>
                            {getFieldDecorator("alinhamento_familia_atividades_quais", {
                                initialValue: registo.alinhamento_escola_familia?.familia_atividades_terapias_quais
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Form.Item label="Combinado entre escola e família / orientações">
                            {getFieldDecorator("alinhamento_combinado_escola_familia", {
                                initialValue: registo.alinhamento_escola_familia?.combinado_escola_familia
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="10. Recomendações finais">
                        <Form.Item label="Cuidados e encaminhamentos necessários, sugestões para os próximos passos">
                            {getFieldDecorator("recomendacoes_finais", {
                                initialValue: registo.recomendacoes_finais
                            })(<TextArea rows={6} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <div className="ant-drawer-footer">
                        <button
                            className="botao-secundario"
                            type="button"
                            onClick={handleClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Cancelar
                        </button>

                        <button className="botao-principal" disabled={isLoading}>
                            {isLoading ? <Icon type="loading" /> : null}
                            Salvar estudo
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({ name: "form-drawer-adicionar-estudo" })(DrawerAdicionarEstudo);
